import userApi from '@/modules/projectA/api/user';
import filingApi from '@/modules/projectA/api/filing';
import QuotationNoticeDialog from '../protocolPopup/quotationNoticeDialog';

export default {
  name: 'quotationNotice',
  data() {
    return {
      quotationNoticeVisible: false,
      rateNum: 0,
    };
  },
  components: {
    QuotationNoticeDialog,
  },
  methods: {
    handleCloseDialog() {
      this.quotationNoticeVisible = false;
    },
    async getRateNum(row) {
      // 备案登记配置
      const { code: recordCode, data: recordData } = await userApi.queryInquiryRate({
        companyId: row.purchaseCompanyId,
      });
      if (recordCode === '200' && recordData) {
        const { customRate = 0, platformRate = 0 } = recordData;
        const totalRate = Number(customRate) + Number(platformRate);
        this.rateNum = totalRate;
      } else {
        const { code: platformCode, data: platformData = [] } = await filingApi.queryConfigList([
          'chargeNotice.enquiryServiceRate',
        ]);

        if (platformCode === '200' && platformData.length > 0) {
          const platformRate = Number(platformData[0]?.configValue) || 0;
          this.rateNum = platformRate * 10;
        }
      }
    },
    /* async getRateNum(row) {
      // 备案登记配置
      const baRateRes = await userApi.queryInquiryRate({
        companyId: row.purchaseCompanyId,
      });
      // 先校验备案 在校验平台
      if (baRateRes.success && baRateRes.data) {
        //   备案得两个费率和    customRate:客户引入方/备案方比例，小数 ;  platformRate:平台方比例，小数
        const baAllRate = baRateRes.data ? Number(baRateRes.data.customRate) + Number(baRateRes.data.platformRate) : 0;
        this.rateNum = baAllRate;
        console.log('备案rateNum:', this.rateNum);
      } else {
        // 无备案，校验平台
        // 平台配置
        const ptRateRes = await filingApi.queryConfigList(['chargeNotice.enquiryServiceRate']);
        this.rateNum = ptRateRes.data && ptRateRes.data.length > 0 ? Number(ptRateRes.data[0].configValue) * 10 : 0;
        console.log('平台-rateNum:', this.rateNum);
      }
    }, */
  },
};
